import { getSecuritiesPurchaseSchema } from './securitiesPurchaseSchema';

export const getSecuritiesSaleSchemas = getSecuritiesPurchaseSchema;
